import { render, staticRenderFns } from "./PhoneNumberActionDialog.vue?vue&type=template&id=5d57f715"
import script from "./PhoneNumberActionDialog.vue?vue&type=script&lang=js"
export * from "./PhoneNumberActionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports